import script from "./Activities.vue?vue&type=script&setup=true&lang=js"
export * from "./Activities.vue?vue&type=script&setup=true&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=62a91b87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a91b87"]])

export default __exports__